// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3Jgl-","ranges":"BmiRanges_ranges__1hyVz"};